import { render } from "./scrollable_advance.vue?vue&type=template&id=d4e9f9a8"
import script from "./scrollable_advance.vue?vue&type=script&lang=js"
export * from "./scrollable_advance.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__